module.exports = __webpack_public_path__ + "img/item-info-icon2.0cf04db9.svg";